// apps/client/src/ui/hud/Controls.tsx — round HUD buttons for the screens that exist (§8.7 HUD): Pockets, Mail and Menu top-right
// beside the bells; Chat and Emotes bottom-left above the joystick. A button whose screen isn't registered is hidden.
import type { StringKey } from '@whiskerton/content';
import type { ReactNode } from 'react';
import { useGame } from '../../state/store';
import { useT } from '../i18n';
import { RoundButton } from '../kit';
import { hasScreen, type ScreenId, type ScreenParams } from '../router';
import { BellsPill } from './BellsPill';
import { Bag, Chat, Envelope, Menu, Smile } from './Icons';

function ScreenButton(p: { id: string; label: StringKey; icon: ReactNode; badge?: boolean }) {
  const t = useT();
  if (!hasScreen(p.id)) return null;
  const id: ScreenId = p.id;
  const open = () => useGame.getState().openScreen(id, undefined as ScreenParams[typeof id]);
  return <RoundButton label={t(p.label)} badge={p.badge} onClick={open}>{p.icon}</RoundButton>;
}
export function Controls() {
  const unread = useGame((s) => ((s as { mailUnread?: number }).mailUnread ?? 0) > 0);
  return (
    <>
      <div data-hud style={{ position: 'absolute', right: 'calc(var(--hud-inset) + env(safe-area-inset-right))', top: 'calc(var(--hud-inset) + env(safe-area-inset-top))',
        display: 'flex', alignItems: 'center', gap: 10 }}>
        <BellsPill />
        <ScreenButton id="pockets" label="hud.pockets" icon={<Bag />} />
        <ScreenButton id="mailbox" label="hud.mail" icon={<Envelope />} badge={unread} />
        <ScreenButton id="menu" label="hud.menu" icon={<Menu />} />
      </div>
      <div data-hud style={{ position: 'absolute', left: 'calc(var(--hud-inset) + env(safe-area-inset-left))', bottom: 'calc(34cqh + env(safe-area-inset-bottom))',
        display: 'flex', flexDirection: 'column', gap: 10 }}>
        <ScreenButton id="chat" label="hud.chat" icon={<Chat />} />
        <ScreenButton id="emotes" label="hud.emotes" icon={<Smile />} />
      </div>
    </>
  );
}
